module.exports = __webpack_public_path__ + "img/rg-vessel-safe.d2da7e8f.svg";